import API from '../index';
import { Order, TaxInfo } from '../../types/common';
import { getTaxInfoPayload } from '../invoiceInfo';

const confirmOrder = async (
  orderId: string,
  options: Record<string, string>,
  taxInfo: TaxInfo,
): Promise<Order> => {
  const { method, token } = options;
  const taxInfoPayload = getTaxInfoPayload(taxInfo);
  const { transaction } = await API.post(`/orders/${orderId}/process`, {
    slug: method,
    token,
    taxInfo: taxInfoPayload,
  });
  return transaction;
};

export default confirmOrder;
